<template>
  <div>
    <v-container fluid>
     <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <v-row>
                <!-- Date picker -->
                <v-col cols="12" md="2" lg="2">
                  <RangeDatePickerMenu
                    v-model="dateRange"
                    showButtons
                    @onOkClick="closeDatepicker"
                  />
                </v-col>
                <!-- /Date picker -->
                <!-- Employee list -->
                <v-col cols="12" md="2" lg="2" v-if="isFinancier">
                  <v-select
                    dense
                    hide-details
                    :items="employee"
                    item-value="employee_id"
                    item-text="full_name"
                    label="Employee"
                    v-model="selectedEmployee"
                    @input="changeEmployee()"
                    clearable
                  >
                    <template v-slot:prepend-item>
                      <div class="px-4 py-2">
                        <v-text-field
                          dense
                          hide-details
                          label="Search employee"
                          v-model="searchEmployee"
                        ></v-text-field>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="2" lg="2" v-if="isFinancier">
                  <v-text-field
                    dense
                    hide-details
                    label="Exchange Rate"
                    v-model="currentExchangeRate"
                    @input="showIcons = true"
                  >
                  <template slot="append" v-if="showIcons">
                    <v-icon color="success" @click="updateExchangeRate">mdi-check-circle</v-icon>
                    <v-icon color="primary" @click="setPreviosRate">mdi-close-circle</v-icon>
                  </template>
                  </v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <!-- /Employee list -->
                <v-col cols="auto" v-if="isFinancier">
                  <v-btn
                    color="primary"
                    outlined
                    small
                    @click.prevent="invoicesDialog = true"
                  >
                    Generate Report
                  </v-btn>
                  <PayrollReport
                    v-model="invoicesDialog"
                  ></PayrollReport>
                </v-col>
                <v-col cols="auto" v-if="isFinancier">
                  <v-btn
                    color="primary"
                    outlined
                    small
                    @click.prevent="setPaymentToAllEmployees"
                  >
                    Set Payment Automatically
                  </v-btn>
                  <PayrollPaymentAutomatically
                    v-model="showPaymentAutomaticallyDialog"
                    :paymentForEmployeeItems = paymentForEmployeeItems
                  ></PayrollPaymentAutomatically>
                </v-col>
                <v-col cols="auto" v-if="isFinancier">
                  <v-btn
                    color="primary"
                    outlined
                    small
                    :disabled="!currentExchangeRate"
                    @click.prevent="setSalaryToAllEmployees"
                  >
                    Set Salary Automatically
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" md="11" lg="11">
                    <h4> Employee's reports </h4>
                    <v-divider></v-divider>
                    <v-data-table
                      fixed-header
                      :headers="headers"
                      :items="currentPayroll"
                      :items-per-page="-1"
                      hide-default-footer
                      height="20vh"
                      class="mb-5"
                    >
                      <!-- Header paid duration -->
                      <template v-slot:[`header.Hours`]="{ header }">
                        {{ header.text }}
                        (Total: {{ totalPaid }})
                      </template>
                      <!-- /Header paid duration -->
                      <template v-slot:[`item.Reported`]="{ item }">
                        {{ item.Reported | moneyFilter }}
                      </template>
                      <template v-slot:[`item.Total`]="{ item }">
                        {{ item.Reported ? '$' + (item.Reported * item.Hours) : '$0.00' }}
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col cols="12" md="1" lg="1" class="mt-5">
                    <v-text-field
                      class="mt-15"
                      label="Salary"
                      readonly
                      v-model="currentSalary"
                    ></v-text-field>
                    <v-text-field
                      class="mt-5"
                      label="Total"
                      readonly
                      v-model="currentTotal"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <h4> Salary </h4>
                <v-divider></v-divider>
                <v-data-table
                  fixed-header
                  :headers="salaryTableHeaders"
                  :items="employeeSalary"
                  :items-per-page="-1"
                  hide-default-footer
                  @click:row="onSalaryRowClick"
                  item-key="Salary_ID"
                  single-select
                  height="16vh"
                >
                  <template v-slot:[`item.Salary`]="{ item }">
                    {{ item.Salary | moneyFilter }}
                  </template>
                    <template v-slot:[`item.Reporting`]="{ item }">
                    {{ item.Reporting | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Premium`]="{ item }">
                    {{ item.Premium | moneyFilter }}
                  </template>
                  <template v-slot:[`item.L_And_D`]="{ item }">
                    {{ item.L_And_D | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Refund`]="{ item }">
                    {{ item.Refund | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Medical_Insurance`]="{ item }">
                    {{ item.Medical_Insurance | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Sport_Compensation`]="{ item }">
                    {{ item.Sport_Compensation | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Dividend`]="{ item }">
                    {{ item.Dividend | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Penalty`]="{ item }">
                    {{ item.Penalty | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Other_Bonuses`]="{ item }">
                    {{ item.Other_Bonuses | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Benefits`]="{ item }">
                    {{ item.Benefits | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Tax`]="{ item }">
                    {{ item.Tax | moneyFilter }}
                  </template>
                  <template v-slot:[`item.Total`]="{ item }">
                    {{ item.Total | moneyFilter}}
                  </template>
                </v-data-table>
                <v-row class="my-4">
                  <v-spacer></v-spacer>
                  <v-btn small color="red darken-2 white--text" :disabled="!isFinancier" @click.prevent="deleteSalary"> Delete </v-btn>
                  <v-btn small v-if="selectedEmployee" outlined color="primary" class="ml-3" @click.prevent="resetSalary"> Reset Salary </v-btn>
                  <v-btn small color="success" class="mx-3" :disabled="!isFinancier" @click.prevent="updateNewSalary(null)"> Add </v-btn>
                  <v-btn small color="primary" :disabled="!isFinancier"  @click.prevent="editSalary"> Edit </v-btn>
                </v-row>
                <h4> Payment </h4>
                <v-divider></v-divider>
                <v-data-table
                  fixed-header
                  :headers="paymentTableHeaders"
                  :items="employeePayments"
                  :items-per-page="-1"
                  hide-default-footer
                  @click:row="onPaymentRowClick"
                  item-key="Payment_ID"
                  single-select
                  height="16vh"
                >
                  <template v-slot:[`item.Amount`]="{ item }">
                    {{ item.Amount | moneyFilter }}
                  </template>
                </v-data-table>
                <v-row class="my-5">
                  <v-spacer></v-spacer>
                  <v-btn small color="red darken-2 white--text" :disabled="!isFinancier" @click.prevent="deletePayment"> Delete </v-btn>
                  <v-btn small color="success" :disabled="!isFinancier" class="mx-3" @click.prevent="addNewPayment"> Add </v-btn>
                  <v-btn small color="primary" :disabled="!isFinancier" @click.prevent="editPayment"> Edit </v-btn>
                </v-row>
                <v-row class="mt-1">
                  <v-col cols="auto" class="d-flex flex-column pa-0">
                    <div class="summary-row mb-1">
                      <span class="summary-label">Start Balance ({{ dateRange[0] }}):</span>
                      <span class="summary-value" :class="{ 'summary-negative': startBalance < 0 }">
                        {{ startBalance | moneyFilter }}
                      </span>
                    </div>
                    <div class="summary-row mb-1">
                      <span class="summary-label">Total Accrued:</span>
                      <span class="summary-value summary-accrued">{{ totalSalary | moneyFilter }}</span>
                    </div>
                    <div class="summary-row mb-1">
                      <span class="summary-label">Total Paid:</span>
                      <span class="summary-value summary-paid">{{ totalPayment | moneyFilter }}</span>
                    </div>
                    <div class="summary-row">
                      <span class="summary-label">End Balance ({{ dateRange[1] }}):</span>
                      <span class="summary-value" :class="{ 'summary-negative': endBalance < 0 }">
                        {{ endBalance | moneyFilter }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Salary dialog -->
    <v-dialog
      v-model="showSalaryDialog"
      max-width="700"
    >
      <v-card>
        <v-card-title>
          Salary
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="showSalaryDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <h5 class="mb-5"> Name </h5>
              <v-select
                dense
                hide-details
                :items="employee"
                item-value="employee_id"
                item-text="full_name"
                v-model="salary.Employee_ID"
                readonly
              >
                <template v-slot:prepend-item>
                  <div class="px-4 py-2">
                    <v-text-field
                      dense
                      hide-details
                      label="Search employee"
                      v-model="searchEmployee"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5 class="color-black">Date</h5>
              <DatePicker
                v-model="salary.Date"
                @onDatePickerChange="updateNewSalary(salary.Date)"
              />
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Salary</h5>
              <v-text-field
                v-model="salary.Salary"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <h5>Reporting</h5>
              <v-text-field
                v-model="salary.Reporting"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Premium</h5>
              <v-text-field
                v-model="salary.Premium"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Other Bonuses</h5>
              <v-text-field
                v-model="salary.Other_Bonuses"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <h5>Sport Compensation</h5>
              <v-text-field
                v-model="salary.Sport_Compensation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Medical Insurance</h5>
              <v-text-field
                v-model="salary.Medical_Insurance"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>L & D</h5>
              <v-text-field
                v-model="salary.L_And_D"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <h5>PM</h5>
              <v-text-field
                v-model="salary.PM"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>SBU</h5>
              <v-text-field
                v-model="salary.SBU"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Dividend</h5>
              <v-text-field
                v-model="salary.Dividend"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" lg="4">
              <h5>Benefits</h5>
              <v-text-field
                v-model="salary.Benefits"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Penalty</h5>
              <v-text-field
                v-model="salary.Penalty"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Tax</h5>
              <v-text-field
                v-model="salary.Tax"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <h5>Refund</h5>
              <v-text-field
                v-model="salary.Refund"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" lg="8">
              <h5>Notes</h5>
              <v-textarea
                v-model="salary.Notes"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveSalary" :disabled="disableSave">Save</v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- /Salary dialog -->
    <!-- Payment dialog -->
    <v-dialog
      v-model="showPaymentDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Payment
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="showPaymentDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h5 class="mb-5"> Name </h5>
              <v-select
                dense
                hide-details
                :items="employee"
                item-value="employee_id"
                item-text="full_name"
                v-model="payment.Employee_ID"
              >
                <template v-slot:prepend-item>
                  <div class="px-4 py-2">
                    <v-text-field
                      dense
                      hide-details
                      label="Search employee"
                      v-model="searchEmployee"
                    ></v-text-field>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h5 class="color-black">Payment Date</h5>
              <DatePicker
                v-model="payment.Payment_Date"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h5>Amount</h5>
              <v-text-field
                v-model="payment.Amount"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h5>Exchange Rate</h5>
              <v-text-field
                v-model="payment.Exchange_Rate"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h5>Payment, UAH</h5>
              <v-text-field
                v-model="payment.Payment_UAH"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h5>Payment Netto, UAH</h5>
              <v-text-field
                v-model="payment.Payment_Netto_UAH"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" lg="6">
              <h5>From</h5>
              <v-textarea
                v-model="payment.From"
                rows="2"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h5>Notes</h5>
              <v-textarea
                v-model="payment.Notes"
                rows="2"
              ></v-textarea>
            </v-col>
          </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="savePayment" :disabled="disableSave">Save</v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- /Payment dialog -->
    <!-- Remove salary dialog -->
    <ConfirmOrDeniedDialog
      v-if="removeSalaryDialog"
      v-model="removeSalaryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :message="'Do you want to delete current salary?'"
      @onDeleteClick="deleteCurrentSalary"
      @onCancelClick="removeSalaryDialog = false"
      @onCloseClick="removeSalaryDialog = false"
    />
    <!-- /Remove salary dialog -->
    <!-- Remove payment dialog -->
    <ConfirmOrDeniedDialog
      v-if="removePaymentDialog"
      v-model="removePaymentDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :message="'Do you want to delete current payment?'"
      @onDeleteClick="deleteCurrentPayment"
      @onCancelClick="removePaymentDialog = false"
      @onCloseClick="removePaymentDialog = false"
    />
    <!-- /Remove payment dialog -->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Payroll',
  components: {
    RangeDatePickerMenu: () => import('@/components/global/RangeDatePickerMenu.vue'),
    PayrollReport: () => import('@/components/payroll/PayrollReport.vue'),
    PayrollPaymentAutomatically: () => import('@/components/payroll/PayrollPaymentAutomatically.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  data () {
    return {
      disableSave: false,
      dates: [
        moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      ],
      selectedEmployee: null,
      search: '',
      searchEmployee: '',
      currentEmployee: null,
      currentPayroll: [],
      employeePayments: [],
      employeeSalary: [],
      salary: {
        Salary_ID: null,
        Employee_ID: null,
        Name: '',
        Date: null,
        Salary: null,
        Premium: null,
        L_And_D: null,
        Medical_Insurance: null,
        Sport_Compensation: null,
        Other_Bonuses: null,
        Benefits: null,
        Reporting: null,
        PM: null,
        SBU: null,
        Dividend: null,
        Tax: null,
        Penalty: null,
        Notes: '',
        Refund: null
      },
      salaryDialog: false,
      paymentDialog: false,
      payment: {
        Payment_ID: null,
        Employee_ID: null,
        Name: '',
        Payment_Date: null,
        Amount: 0,
        Exchange_Rate: 0,
        Payment_UAH: 0,
        Payment_Netto_UAH: 0,
        From: '',
        Notes: ''
      },
      rolesOfCurrentUser: [],
      selectedSalaryRow: {},
      selectedPaymentRow: {},
      totalPaid: 0,
      currentSalary: 0.00,
      currentTotal: 0.00,
      removeSalaryDialog: false,
      removePaymentDialog: false,
      invoicesDialog: false,
      currentExchangeRate: null,
      showIcons: false,
      balanceOfEmployee: 0.00,
      startBalance: 0.00,
      endBalance: 0.00,
      paymentAutomaticallyDialog: false,
      paymentForEmployeeItems: [],
      salaryTableHeaders: [
        {
          text: 'Salary Date',
          value: 'Salary_Date',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Name',
          value: 'Full_Name',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Salary',
          value: 'Salary',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Reporting',
          value: 'Reporting',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Premium',
          value: 'Premium',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'L and D',
          value: 'L_And_D',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Medical Insurance',
          value: 'Medical_Insurance',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Sport Compensation',
          value: 'Sport_Compensation',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Refund',
          value: 'Refund',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Other Bonuses',
          value: 'Other_Bonuses',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Benefits',
          value: 'Benefits',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'PM',
          value: 'PM',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'SBU',
          value: 'SBU',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Dividend',
          value: 'Dividend',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Penalty',
          value: 'Penalty',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Total',
          value: 'Total',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Tax',
          value: 'Tax',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ],
      paymentTableHeaders: [
        {
          text: 'Payment Date',
          value: 'Payment_Date',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Amount',
          value: 'Amount',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Exchange Rate',
          value: 'Exchange_Rate',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Payment, UAH',
          value: 'Payment_UAH',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Payment Netto, UAH',
          value: 'Payment_Netto_UAH',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    dateRange: {
      get () {
        return this.dates
      },
      set (value) {
        this.dates = value.sort((a, b) => {
          const dA = new Date(a)
          const dB = new Date(b)
          if (+dA > +dB) return 1
          if (+dA < +dB) return -1
          return 0
        })
      }
    },
    showSalaryDialog: {
      get () {
        return this.salaryDialog
      },
      set (val) {
        if (!val) {
          this.clearCurrentSalary()
        }
        this.salaryDialog = val
      }
    },
    showPaymentDialog: {
      get () {
        return this.paymentDialog
      },
      set (val) {
        if (!val) {
          this.clearCurrentPayment()
        }
        this.paymentDialog = val
      }
    },
    showPaymentAutomaticallyDialog: {
      get () {
        return this.paymentAutomaticallyDialog
      },
      set (val) {
        this.paymentAutomaticallyDialog = val
        if (!val) {
          this.getPayment()
          this.getBalanceOfEmployee()
        }
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    employee () {
      const r = new RegExp(this.searchEmployee, 'gi')
      return this.$store.getters.getEmployee.filter(item => {
        r.lastIndex = 0
        return r.test(item.full_name)
      })
    },
    totalSalary () {
      return this.employeeSalary.reduce((sum, item) => sum + (item.Total || 0), 0)
    },
    totalPayment () {
      return this.employeePayments.reduce((sum, item) => sum + (item.Amount || 0), 0)
    },
    headers () {
      return [
        {
          text: 'Project',
          value: 'ProjectName',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Hours',
          value: 'Hours',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2'
        },
        {
          text: 'Reported',
          value: 'Reported',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'PM',
          value: 'PM',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'SBU',
          value: 'SBU',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 cursor-pointer'
        },
        {
          text: 'Total',
          value: 'Total',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 cursor-pointer'
        }
      ]
    },
    isFinancier () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
        }
      }
      return res
    },
    allEmployee () {
      return this.$store.getters.getAllEmployee.filter(item => !item.Is_Deleted)
    },
    updateSalary () {
      return this.$store.getters.getUpdateSalary
    }
  },
  mounted () {
    this.getEmployee()
    this.getEmployeeList()
    this.getRolesOfCurrentUser()
    this.getPayrollByPeriod()
    this.getPayment()
    this.getSalary()
    this.getCurrentExchangeRate()
    this.getBalanceOfEmployee()
    this.getCurrentSalary()
    this.getPotentialSalaryByPeriod()
  },
  methods: {
    closeDatepicker () {
      this.getPayrollByPeriod()
      this.getPayment()
      this.getSalary()
      this.getBalanceOfEmployee()
      this.getPotentialSalaryByPeriod()
    },
    getEmployee () {
      this.axios.get('/api/employee', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.setEmployeeList(0, res.data)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response ? error.response.data : '' })
      })
    },
    getEmployeeList () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getCurrentExchangeRate () {
      this.axios.get('/api/exhangerate/currenetrate', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.currentExchangeRate = res.data[0].Rate
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    setEmployeeList (beginNumber, employee) {
      const empl = []
      for (let i = beginNumber; i < beginNumber + 100; i++) {
        if (employee[i]) {
          empl.push(employee[i])
        } else {
          break
        }
      }
      if (empl.length) this.$store.dispatch('addEmployee', { employee: empl })
      setTimeout(() => {
        this.setEmployeeList(beginNumber + 100, employee)
      })
    },
    getPayrollByPeriod () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      this.axios.get(`/api/payroll/${currentEmployee}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.getReportedPayroll(currentEmployee)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getReportedPayroll (employeeId) {
      this.axios.get(`/api/payroll/reported/${employeeId}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.totalPaid = 0
        for (let i = 0; i < res.data.length; i++) {
          this.totalPaid += res.data[i].Hours
        }
        this.currentPayroll = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getPayment () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      this.axios.get(`/api/payment/${currentEmployee}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeePayments = []
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].Payment_Date = res.data[i].Payment_Date.substring(0, 10)
          this.employeePayments.push(res.data[i])
        }
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getSalary () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      this.axios.get(`/api/salary/${currentEmployee}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeSalary = []
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].Salary_Date = res.data[i].Salary_Date.substring(0, 10)
          res.data[i].Total = res.data[i].Salary + res.data[i].Reporting + res.data[i].Premium + res.data[i].Dividend + res.data[i].Sport_Compensation + res.data[i].L_And_D + res.data[i].Medical_Insurance + res.data[i].Other_Bonuses + res.data[i].Benefits + res.data[i].Refund - res.data[i].Penalty
          this.employeeSalary.push(res.data[i])
        }
        this.$store.dispatch('updateSalary', { update: false })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    setSalaryToAllEmployees () {
      if (this.dateRange[1] > this.dateRange[0]) {
        const body = {
          From_Date: this.dateRange[0],
          To_Date: this.dateRange[1],
          SentNotificationFor: this.user.employee_id,
          CurrentExchangeRate: this.currentExchangeRate
        }
        this.axios.post('/api/salary/automaticsalary', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('showOverlay', { show: true })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Set right date range to calculate salary' })
      }
    },
    setPaymentToAllEmployees () {
      this.paymentForEmployeeItems = []
      this.axios.get('/api/payment/getemployeeforpayment', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].Balance === 0) {
            res.data[i].Payment = 0
          } else if (res.data[i].Balance < 0) {
            res.data[i].Payment = res.data[i].Salary + res.data[i].Balance
          } else {
            if (res.data[i].Salary - res.data[i].Balance > 0) {
              res.data[i].Payment = res.data[i].Balance
            } else if (res.data[i].Salary - res.data[i].Balance === 0) {
              res.data[i].Payment = res.data[i].Salary
            } else {
              res.data[i].Payment = res.data[i].Balance
            }
          }
          this.paymentForEmployeeItems.push(res.data[i])
        }
        this.showPaymentAutomaticallyDialog = true
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getRolesOfCurrentUser () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onSalaryRowClick (item, row) {
      this.selectedSalaryRow = {}
      row.select(true)
      this.selectedSalaryRow = row
      if (this.selectedPaymentRow) {
        this.selectedPaymentRow.isSelected = false
        this.selectedPaymentRow = {}
      }
    },
    onPaymentRowClick (item, row) {
      this.selectedPaymentRow = {}
      row.select(true)
      this.selectedPaymentRow = row
      if (this.selectedSalaryRow) {
        this.selectedSalaryRow.isSelected = false
        this.selectedSalaryRow = {}
      }
    },
    updateNewSalary (date) {
      if (!this.salary.Salary_ID) {
        let dateFrom = null
        let dateTo = null
        if (date) {
          dateFrom = moment(date).startOf('month').format('YYYY-MM-DD')
          dateTo = moment(date).endOf('month').format('YYYY-MM-DD')
        } else {
          dateFrom = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
          this.salary.Date = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
          dateTo = this.salary.Date
        }
        if (this.selectedEmployee) {
          this.salary.Employee_ID = this.selectedEmployee
        } else {
          this.salary.Employee_ID = this.user.employee_id
        }
        this.axios.get(`/api/salary/getsalaryforemployee/${this.salary.Employee_ID}/${dateFrom}/${dateTo}/${this.currentExchangeRate}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.salary.Salary_ID = null
          this.salary.Salary = result.data[0].Salary
          this.salary.Reporting = result.data[0].Reporting
          this.salary.Name = result.data[0].Full_name
          this.salary.PM = null
          this.salary.SBU = null
          this.salary.Dividend = null
          this.salary.Premium = result.data[0].Premium
          this.salary.Sport_Compensation = result.data[0].Sport_Compensation
          this.salary.Medical_Insurance = result.data[0].Medical_Insurance
          this.salary.L_And_D = result.data[0].L_And_D
          this.salary.Refund = null
          this.salary.Other_Bonuses = null
          this.salary.Benefits = null
          this.salary.Tax = null
          this.salary.Penalty = null
          this.salary.Notes = null
          this.showSalaryDialog = true
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    saveSalary () {
      this.disableSave = true
      if (this.salary.Salary_ID) {
        this.axios.put(`/api/salary/${this.salary.Salary_ID}`, this.salary, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.disableSave = false
          this.showSalaryDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Salary successfully updated' })
          this.getSalary()
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.post('/api/salary', this.salary, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.disableSave = false
          this.showSalaryDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Salary successfully added' })
          this.getSalary()
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    editSalary () {
      if (this.selectedSalaryRow && this.selectedSalaryRow.item) {
        this.salary.Salary_ID = this.selectedSalaryRow.item.Salary_ID
        this.axios.get(`/api/salary/${this.salary.Salary_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.salary.Employee_ID = res.data[0].Employee_ID
          this.salary.Name = res.data[0].Name
          this.salary.Date = new Date(res.data[0].Salary_Date).toISOString().substr(0, 10)
          this.salary.Salary = res.data[0].Salary
          this.salary.Reporting = res.data[0].Reporting
          this.salary.Sport_Compensation = res.data[0].Sport_Compensation
          this.salary.Medical_Insurance = res.data[0].Medical_Insurance
          this.salary.L_And_D = res.data[0].L_And_D
          this.salary.Other_Bonuses = res.data[0].Other_Bonuses
          this.salary.Refund = res.data[0].Refund
          this.salary.Benefits = res.data[0].Benefits
          this.salary.PM = res.data[0].PM
          this.salary.SBU = res.data[0].SBU
          this.salary.Dividend = res.data[0].Dividend
          this.salary.Tax = res.data[0].Tax
          this.salary.Premium = res.data[0].Premium
          this.salary.Penalty = res.data[0].Penalty
          this.salary.Notes = res.data[0].Notes
          this.showSalaryDialog = true
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Please select the salary to edit' })
      }
    },
    deleteSalary () {
      if (this.selectedSalaryRow && this.selectedSalaryRow.item && this.selectedSalaryRow.item.Salary_ID) {
        this.removeSalaryDialog = true
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Please select the salary to remove' })
      }
    },
    deleteCurrentSalary () {
      this.axios.delete(`/api/salary/${this.selectedSalaryRow.item.Salary_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.removeSalaryDialog = false
        this.$store.dispatch('setSuccess', { successMsg: 'Salary successfully deleted' })
        this.selectedSalaryRow = {}
        this.getSalary()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    addNewPayment () {
      if (this.selectedEmployee) {
        this.payment.Employee_ID = this.selectedEmployee
      } else {
        this.payment.Employee_ID = this.user.employee_id
      }
      this.payment.Payment_Date = new Date().toISOString().substr(0, 10)
      this.showPaymentDialog = true
    },
    editPayment () {
      if (this.selectedPaymentRow && this.selectedPaymentRow.item) {
        this.payment.Payment_ID = this.selectedPaymentRow.item.Payment_ID
        this.axios.get(`/api/payment/${this.payment.Payment_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.payment.Employee_ID = res.data[0].Employee_ID
          this.payment.Name = res.data[0].Name
          this.payment.Payment_Date = new Date(res.data[0].Payment_Date).toISOString().substr(0, 10)
          this.payment.Amount = res.data[0].Amount
          this.payment.Exchange_Rate = res.data[0].Exchange_Rate
          this.payment.Payment_UAH = res.data[0].Payment_UAH
          this.payment.Payment_Netto_UAH = res.data[0].Payment_Netto_UAH
          this.payment.From = res.data[0].From
          this.payment.Notes = res.data[0].Notes
          this.showPaymentDialog = true
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Please select the payment to edit' })
      }
    },
    deletePayment () {
      if (this.selectedPaymentRow && this.selectedPaymentRow.item && this.selectedPaymentRow.item.Payment_ID) {
        this.removePaymentDialog = true
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Please select the payment to remove' })
      }
    },
    deleteCurrentPayment () {
      this.axios.delete(`/api/payment/${this.selectedPaymentRow.item.Payment_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.removePaymentDialog = false
        this.$store.dispatch('setSuccess', { successMsg: 'Payment successfully deleted' })
        this.selectedPaymentRow = {}
        this.getPayment()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    savePayment () {
      this.disableSave = true
      if (this.payment.Payment_ID) {
        this.axios.put(`/api/payment/${this.payment.Payment_ID}`, this.payment, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.disableSave = false
          this.showPaymentDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Payment successfully updated' })
          this.getPayment()
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.post('/api/payment', this.payment, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.disableSave = false
          this.showPaymentDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Payment successfully added' })
          this.getPayment()
        }).catch(error => {
          this.disableSave = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    changeEmployee () {
      this.getPayrollByPeriod()
      this.getPayment()
      this.getSalary()
      this.getBalanceOfEmployee()
      this.getCurrentSalary()
      this.getPotentialSalaryByPeriod()
      this.selectedSalaryRow = {}
      this.selectedPaymentRow = {}
      this.searchEmployee = ''
    },
    setPreviosRate () {
      this.getCurrentExchangeRate()
    },
    updateExchangeRate () {
      const body = {
        Date_of_Update: new Date().toISOString().substr(0, 10),
        Rate: this.currentExchangeRate
      }
      this.axios.post('/api/exchangerate', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.currentExchangeRate = res.data[0].Rate
        this.$store.dispatch('setSuccess', { successMsg: 'Exchange rate successfully updated' })
        this.showIcons = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    clearCurrentSalary () {
      this.salary.Salary_ID = null
      this.salary.Employee_ID = null
      this.salary.Name = null
      this.salary.Date = null
      this.salary.Salary = null
      this.salary.Reporting = null
      this.salary.Sport_Compensation = null
      this.salary.Medical_Insurance = null
      this.salary.L_And_D = null
      this.salary.Refund = null
      this.salary.Other_Bonuses = null
      this.salary.Benefits = null
      this.salary.PM = null
      this.salary.SBU = null
      this.salary.Dividend = null
      this.salary.Tax = null
      this.salary.Premium = null
      this.salary.Penalty = null
      this.salary.Notes = null
    },
    clearCurrentPayment () {
      this.payment.Payment_ID = null
      this.payment.Employee_ID = null
      this.payment.Name = null
      this.payment.Payment_Date = null
      this.payment.Amount = null
      this.payment.Exchange_Rate = null
      this.payment.Payment_UAH = null
      this.payment.Payment_Netto_UAH = null
      this.payment.From = null
      this.payment.Notes = null
    },
    resetSalary () {
      const body = {
        From_Date: this.dateRange[0],
        To_Date: this.dateRange[1],
        ExchangeRate: this.currentExchangeRate
      }
      this.axios.put(`/api/salary/resetsalary/${this.selectedEmployee}`, body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.getSalary()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getBalanceOfEmployee () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      const startDate = moment(this.dateRange[0]).subtract(1, 'days').format('YYYY-MM-DD')
      this.axios.get(`/api/balanceofemployee/${currentEmployee}/${startDate}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.startBalance = res.data[0]?.Balance || 0
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
      this.axios.get(`/api/balanceofemployee/${currentEmployee}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.endBalance = res.data[0]?.Balance || 0
        this.balanceOfEmployee = res.data[0]?.Balance || 0
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getCurrentSalary () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      this.axios.get(`/api/salary/currentsalary/${currentEmployee}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.currentSalary = res.data[0].Salary
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getPotentialSalaryByPeriod () {
      let currentEmployee = null
      if (!this.selectedEmployee) {
        currentEmployee = this.user.employee_id
      } else {
        currentEmployee = this.selectedEmployee
      }
      this.axios.get(`/api/salary/salarybyperiod/${currentEmployee}/${this.dateRange[0]}/${this.dateRange[1]}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.currentTotal = res.data[0].Total
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  },
  watch: {
    updateSalary (a, b) {
      if (a) {
        this.getSalary()
      }
    }
  },
  filters: {
    moneyFilter (val) {
      return val ? '$' + val.toLocaleString('en', { useGrouping: false, minimumFractionDigits: 2 }) : '$0.00'
    },
    valToFixed (val) {
      if ((Math.ceil(val * 100) % 10) !== 0) return (+val).toFixed(2)
      if ((Math.ceil(val * 100) % 100) !== 0) return (+val).toFixed(1)
      return (+val).toFixed(0)
    }
  }
}
</script>
<style lang="scss">
  tr.v-data-table__selected {
    background: #d2d4dd !important;
  }
  .bg-red {
    .v-text-field__slot {
      background-color: tomato;
    }
  }
  .bg-green {
    .v-text-field__slot {
      background-color: lightgreen;
    }
  }
  .summary-row {
    display: flex;
    align-items: center;
  }
  .summary-label {
    font-weight: 500;
    margin-right: 8px;
    font-size: 1.1em;
    min-width: 220px;
  }
  .summary-value {
    font-weight: 600;
    color: #4CAF50;
    font-size: 1.1em;
  }
  .summary-negative {
    color: #F44336 !important;
  }
  .summary-accrued {
    color: #2196F3;
  }
  .summary-paid {
    color: #2196F3;
  }
  .theme--dark {
    .summary-label {
      color: rgba(255, 255, 255, 0.87);
    }
    .summary-value {
      color: #69F0AE;
    }
    .summary-negative {
      color: #FF5252 !important;
    }
    .summary-accrued {
      color: #64B5F6;
    }
    .summary-paid {
      color: #64B5F6;
    }
  }
  .theme--light {
    .summary-label {
      color: rgba(0, 0, 0, 0.87);
    }
  }
</style>
